import React, { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "src/redux/user/actions";
import { HTTPService } from "src/services/httpservice";
import { getHttpClient } from "src/services/rest-api";
import ChangePasswordLayout, {
  ChangePasswordFormType,
} from "src/layouts/changePassword/changePassword.layout";
import { SnackbarProps } from "src/interfaces/snackbar";
import TyfhuSnack from "src/components/TyfhuSnack";
import StorageService from "src/storage";

const ChangePassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [snack, setSnack] = useState<SnackbarProps>({
    open: false,
    message: "",
    severity: "error",
  });

  const handleClose = useCallback(() => {
    setSnack((prev) => ({ ...prev, open: false }));
  }, []);

  const onChangePassword = useCallback(
    async (values: ChangePasswordFormType) => {
      try {
        // Only send password to avoid backend Zod strict validation errors
        await getHttpClient(HTTPService.SET_PASSWORD, "PUT", {
          password: values.password,
        });
        StorageService.token.clearAll();
        await dispatch(logout());
        navigate("/login", {
          state: {
            successMessage: "Password updated successfully. Please log in with your new password.",
          },
        });
      } catch (e: any) {
        let errorMsg = e?.message || "Something went wrong";
        if (e?.errors && Array.isArray(e.errors)) {
          errorMsg = e.errors.map((err: any) => err.message).join(". ");
        }
        setSnack({
          open: true,
          message: errorMsg,
          severity: "error",
        });
      }
    },
    [dispatch, navigate]
  );

  return (
    <>
      <ChangePasswordLayout onSubmit={onChangePassword} />
      <TyfhuSnack snackbar={snack} handleClose={handleClose} />
    </>
  );
};

export default ChangePassword;